import DataTable from 'components/DataTable';
import ListWrapper from 'components/ListWrapper';
import Typography from 'components/Typography';
import {DataTableSchemaItem} from 'types';
import useBlogs from './useBlogs';
import Button from 'components/Button';
import styles from './blogs.module.scss';
import BlogPagination from 'components/BlogPagination';

const SCHEMA: DataTableSchemaItem[] = [
  {
    dataKey: 'title',
    header: 'Title',
  },
  {dataKey: 'image', header: 'Image'},
  {dataKey: 'created_at', header: 'Created Date'},
  {
    dataKey: 'active',
    header: 'Published',
    align: 'right',
  },
  {dataKey: 'view', header: ''},
];

function Index() {
  const {
    data,
    isLoading,
    currentPage,
    setCurrentPage,
    totalPages,
    count,
    pageSize,
    setPageSize,
    onRowClick,
  } = useBlogs();

  return (
    <>
      <div className={styles.header}>
        <Typography variant="h2">Blogs</Typography>
        <Button component="a" to="/website/blogs/create" color="blue">
          Add Blog
        </Button>
      </div>
      <ListWrapper>
        <DataTable
          onClick={onRowClick}
          schema={SCHEMA}
          data={data}
          loading={isLoading}
        />
        {totalPages > 1 && (
          <BlogPagination
            count={count}
            basePath="/blogs"
            page={currentPage}
            total={totalPages}
            setCurrentPage={setCurrentPage}
            pageSize={pageSize}
            setPageSize={setPageSize}
          />
        )}
      </ListWrapper>
    </>
  );
}

export default Index;
